import React, { useContext } from "react";
import Socials from "./socials";
import { Link } from "react-router-dom";
import { CompanyInfoContext } from "../../App";
import { ChevronRight, Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  const companyInfo = useContext(CompanyInfoContext) || {};
  const hasSocials =
    Array.isArray(companyInfo?.company_social) &&
    companyInfo.company_social.length > 0;

  const currentYear = new Date().getFullYear();

  return (
    <footer className="cht-bg-[#0f172a] cht-text-white cht-pt-14 sm:cht-pt-16 cht-border-t cht-border-slate-800 !cht-font-body">
      <div className="cht-max-w-7xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8 cht-pb-12">
        <div className="cht-grid cht-grid-cols-1 sm:cht-grid-cols-2 lg:cht-grid-cols-4 cht-gap-8 sm:cht-gap-10">
          
          {/* Column 1: Company */}
          <div className="cht-space-y-4">
            <h4 className="!cht-font-heading cht-text-base !cht-font-bold cht-text-white cht-tracking-tight">
              Company
            </h4>
            <ul className="cht-space-y-2.5 cht-p-0 cht-m-0 cht-list-none">
              <li>
                <Link
                  className="cht-inline-flex cht-items-center cht-gap-1.5 cht-text-xs sm:cht-text-sm cht-text-slate-400 hover:cht-text-white cht-transition-colors cht-no-underline"
                  to="/about"
                >
                  <ChevronRight size={13} className="cht-text-[#3e57da]" />
                  <span>About Us</span>
                </Link>
              </li>
              <li>
                <Link
                  className="cht-inline-flex cht-items-center cht-gap-1.5 cht-text-xs sm:cht-text-sm cht-text-slate-400 hover:cht-text-white cht-transition-colors cht-no-underline"
                  to="/services"
                >
                  <ChevronRight size={13} className="cht-text-[#3e57da]" />
                  <span>Engineering Services</span>
                </Link>
              </li>
              <li>
                <Link
                  className="cht-inline-flex cht-items-center cht-gap-1.5 cht-text-xs sm:cht-text-sm cht-text-slate-400 hover:cht-text-white cht-transition-colors cht-no-underline"
                  to="/recent-jobs"
                >
                  <ChevronRight size={13} className="cht-text-[#3e57da]" />
                  <span>Featured Deliverables</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 2: Quick Links */}
          <div className="cht-space-y-4">
            <h4 className="!cht-font-heading cht-text-base !cht-font-bold cht-text-white cht-tracking-tight">
              Legal & Policies
            </h4>
            <ul className="cht-space-y-2.5 cht-p-0 cht-m-0 cht-list-none">
              <li>
                <Link
                  className="cht-inline-flex cht-items-center cht-gap-1.5 cht-text-xs sm:cht-text-sm cht-text-slate-400 hover:cht-text-white cht-transition-colors cht-no-underline"
                  to="/careers"
                >
                  <ChevronRight size={13} className="cht-text-[#3e57da]" />
                  <span>Careers</span>
                </Link>
              </li>
              <li>
                <Link
                  className="cht-inline-flex cht-items-center cht-gap-1.5 cht-text-xs sm:cht-text-sm cht-text-slate-400 hover:cht-text-white cht-transition-colors cht-no-underline"
                  to="/privacy-policy"
                >
                  <ChevronRight size={13} className="cht-text-[#3e57da]" />
                  <span>Privacy Policy</span>
                </Link>
              </li>
              <li>
                <Link
                  className="cht-inline-flex cht-items-center cht-gap-1.5 cht-text-xs sm:cht-text-sm cht-text-slate-400 hover:cht-text-white cht-transition-colors cht-no-underline"
                  to="/return-policy"
                >
                  <ChevronRight size={13} className="cht-text-[#3e57da]" />
                  <span>Return Policy</span>
                </Link>
              </li>
              <li>
                <Link
                  className="cht-inline-flex cht-items-center cht-gap-1.5 cht-text-xs sm:cht-text-sm cht-text-slate-400 hover:cht-text-white cht-transition-colors cht-no-underline"
                  to="/terms-and-conditions"
                >
                  <ChevronRight size={13} className="cht-text-[#3e57da]" />
                  <span>Terms and Conditions</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Training & Academics */}
          <div className="cht-space-y-4">
            <h4 className="!cht-font-heading cht-text-base !cht-font-bold cht-text-white cht-tracking-tight">
              Learning Academy
            </h4>
            <ul className="cht-space-y-2.5 cht-p-0 cht-m-0 cht-list-none">
              <li>
                <Link
                  className="cht-inline-flex cht-items-center cht-gap-1.5 cht-text-xs sm:cht-text-sm cht-text-slate-400 hover:cht-text-white cht-transition-colors cht-no-underline"
                  to="/courses"
                >
                  <ChevronRight size={13} className="cht-text-[#3e57da]" />
                  <span>Practical Courses</span>
                </Link>
              </li>
              <li>
                <Link
                  className="cht-inline-flex cht-items-center cht-gap-1.5 cht-text-xs sm:cht-text-sm cht-text-slate-400 hover:cht-text-white cht-transition-colors cht-no-underline"
                  to="/signup"
                >
                  <ChevronRight size={13} className="cht-text-[#3e57da]" />
                  <span>Start Career Registration</span>
                </Link>
              </li>
              <li>
                <Link
                  className="cht-inline-flex cht-items-center cht-gap-1.5 cht-text-xs sm:cht-text-sm cht-text-slate-400 hover:cht-text-white cht-transition-colors cht-no-underline"
                  to="/login"
                >
                  <ChevronRight size={13} className="cht-text-[#3e57da]" />
                  <span>Student Portal Login</span>
                </Link>
              </li>
              <li>
                <Link
                  className="cht-inline-flex cht-items-center cht-gap-1.5 cht-text-xs sm:cht-text-sm cht-text-slate-400 hover:cht-text-white cht-transition-colors cht-no-underline"
                  to="/verify"
                >
                  <ChevronRight size={13} className="cht-text-[#3e57da]" />
                  <span>Credential Registry</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Get in Touch */}
          <div className="cht-space-y-4">
            <h4 className="!cht-font-heading cht-text-base !cht-font-bold cht-text-white cht-tracking-tight">
              Contact Us
            </h4>
            <div className="cht-space-y-3">
              {companyInfo?.email && (
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="cht-flex cht-items-center cht-gap-2.5 cht-text-xs sm:cht-text-sm cht-text-slate-400 hover:cht-text-white cht-transition-colors cht-no-underline"
                >
                  <Mail size={15} className="cht-text-[#3e57da] cht-shrink-0" />
                  <span>{companyInfo.email}</span>
                </a>
              )}

              {companyInfo?.telephone && (
                <a
                  href={`tel:${companyInfo.telephone}`}
                  className="cht-flex cht-items-center cht-gap-2.5 cht-text-xs sm:cht-text-sm cht-text-slate-400 hover:cht-text-white cht-transition-colors cht-no-underline"
                >
                  <Phone size={15} className="cht-text-[#3e57da] cht-shrink-0" />
                  <span>{companyInfo.telephone}</span>
                </a>
              )}

              {companyInfo?.company_address && (
                <div className="cht-flex cht-items-start cht-gap-2.5 cht-text-xs sm:cht-text-sm cht-text-slate-400">
                  <MapPin size={15} className="cht-text-[#3e57da] cht-shrink-0 cht-mt-0.5" />
                  <span className="cht-leading-relaxed">{companyInfo.company_address}</span>
                </div>
              )}
            </div>
          </div>

        </div>
      </div>

      {/* Bottom Sub-bar */}
      <div className="cht-border-t cht-border-slate-800/80 cht-py-6 cht-bg-[#0a0f1d]">
        <div className="cht-max-w-7xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8 cht-flex cht-flex-col sm:cht-flex-row cht-items-center cht-justify-between cht-gap-4">
          <p className="cht-text-xs cht-text-slate-400 cht-mb-0">
            &#169; {currentYear} Codehub Technologies LTD. All rights reserved.
          </p>

          {hasSocials && (
            <div className="cht-flex cht-items-center cht-gap-2">
              <Socials small={true} socials={companyInfo.company_social} />
            </div>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;

